import React, { FC, useCallback } from 'react';
import { IconButton } from '../IconButton';
import { i18n } from '../../../i18n';

interface Props {
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement>;
  clearField?: () => void;
}

export const ClearInputButton: FC<Props> = ({ inputRef, clearField }) => {
  const resetField = useCallback(() => {
    if (clearField) {
      clearField();
    }
    if (!inputRef.current) {
      return;
    }
    inputRef.current.value = '';
    inputRef.current.focus();
  }, [inputRef, clearField]);

  return (
    <IconButton
      onClick={resetField}
      variant="ghost"
      size="sm"
      ariaLabel={i18n.t('Clear field')}
      icon={{ prefix: 'fas', iconName: 'xmark-circle' }}
    />
  );
};
